import React from 'react'

export function ContactsIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M21 1H5C4 1 3 2 3 3v18c0 1 1 2 2 2h17-2v-4h1V1z'
        stroke='currentColor'
        strokeWidth={2}
      />
      <path d='M20 19H5c-1 0-2 .8-2 2' stroke='currentColor' strokeWidth={2} />
      <circle cx={12} cy={7} r={2} stroke='currentColor' strokeWidth={2} />
      <path
        d='M16 16v-2a2 2 0 00-2-2h-4a2 2 0 00-2 2v2'
        stroke='currentColor'
        strokeWidth={2}
      />
    </svg>
  )
}
